/* Dar Senosi — Shopify theme interactions
   - Reveal observer
   - Parallax (data-par)
   - Artist carousel (#artrack)
   - Cart count refresh
   Hash-routed SPA mockup has been removed; Shopify renders pages server-side.
*/
(function(){
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal */
  function observeReveals(){
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal:not(.in)').forEach(function(el, i){
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(el);
    });
  }

  /* parallax */
  function setPar(){
    var vh = window.innerHeight;
    document.querySelectorAll('[data-par]').forEach(function(el){
      try {
        var host = el.closest('section') || el.parentElement;
        if (!host) return;
        var r = host.getBoundingClientRect();
        if (r.bottom < -40 || r.top > vh + 40) return;
        var prog = (vh - r.top) / (vh + r.height);
        var range = parseFloat(el.dataset.par) || 0;
        var y = ((0.5 - prog) * range * 2).toFixed(1);
        el.style.transform = 'translate3d(0,' + y + 'px,0) scale(' + (el.dataset.scale || 1) + ')';
      } catch(e){}
    });
  }
  function parLoop(){ setPar(); requestAnimationFrame(parLoop); }

  /* artist carousel */
  function initArtistCarousel(){
    var track = document.getElementById('artrack');
    if (!track) return;
    var slides = track.children.length;
    if (!slides) return;
    var dotsWrap = document.getElementById('adots');
    var prevBtn = document.getElementById('aprev');
    var nextBtn = document.getElementById('anext');
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    var i = 0, timer;
    for (var s = 0; s < slides; s++){
      (function(idx){
        var b = document.createElement('button');
        b.className = 'dot' + (idx === 0 ? ' on' : '');
        b.setAttribute('aria-label', 'Slide ' + (idx + 1));
        b.onclick = function(){ go(idx); };
        dotsWrap.appendChild(b);
      })(s);
    }
    var dots = Array.prototype.slice.call(dotsWrap.children);
    function go(n){
      i = (n + slides) % slides;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function(d, k){ d.classList.toggle('on', k === i); });
      restart();
    }
    if (nextBtn) nextBtn.onclick = function(){ go(i + 1); };
    if (prevBtn) prevBtn.onclick = function(){ go(i - 1); };
    function restart(){
      clearInterval(timer);
      if (!reduce) timer = setInterval(function(){ go(i + 1); }, 8000);
    }
    restart();
  }

  /* collection carousel — horizontal scroll with arrow controls */
  function initCollectionCarousel(){
    document.querySelectorAll('.coll-carousel').forEach(function(carousel){
      var track = carousel.querySelector('.coll-carousel__track');
      var prev = carousel.querySelector('.coll-carousel__arr--prev');
      var next = carousel.querySelector('.coll-carousel__arr--next');
      if (!track || !prev || !next) return;

      function step(){
        var first = track.querySelector('.hcard');
        if (!first) return 320;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 24) || 24;
        return first.getBoundingClientRect().width + gap;
      }
      function update(){
        var max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function(){ track.scrollBy({ left:  step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* product card image cycling — URLs embedded in data-images (no /product.js wait) */
  function initProductCards(){
    function parseEmbedded(img){
      var raw = img.getAttribute('data-images');
      if (!raw) return null;
      try {
        var list = JSON.parse(raw);
        return Array.isArray(list) && list.length ? list : null;
      } catch (e) { return null; }
    }
    function prefetch(src){
      if (!src) return;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = src;
    }
    function neighbors(list, i){
      if (!list || list.length < 2) return;
      prefetch(list[(i + 1) % list.length]);
      prefetch(list[(i - 1 + list.length) % list.length]);
    }

    document.querySelectorAll('.pcard').forEach(function(card){
      var nav = card.querySelector('.pcard__nav');
      if (!nav) return;
      var img = card.querySelector('.pcard__media img');
      if (!img) return;
      var handle = card.querySelector('a.pcard__link');
      var url = handle ? handle.getAttribute('href') : '';
      var images = parseEmbedded(img);
      var idx = 0;
      var dots = card.querySelectorAll('.pcard__dots span');
      var loading = false;

      function loadImages(cb){
        if (images) { cb(); return; }
        if (loading) return;
        if (!url) return;
        loading = true;
        fetch(url + '.js').then(function(r){ return r.json(); }).then(function(p){
          images = (p.images || []).map(function(src){
            return src.replace(/(\.[a-z]+)(\?|$)/i, '_700x$1$2');
          });
          if (!images.length) images = [img.currentSrc || img.getAttribute('src')];
          loading = false;
          cb();
        }).catch(function(){ loading = false; });
      }

      function show(i){
        if (!images || !images.length) return;
        idx = i;
        var src = images[idx];
        img.src = src;
        img.removeAttribute('srcset');
        dots.forEach(function(d, di){ d.classList.toggle('on', di === idx); });
        neighbors(images, idx);
      }

      function go(dir){
        function step(){
          if (!images || images.length < 2) return;
          show((idx + dir + images.length) % images.length);
        }
        if (images) step();
        else loadImages(step);
      }

      nav.querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          go(parseInt(btn.dataset.dir, 10) || 1);
        });
      });

      /* Touch: swipe media without Prev/Next buttons */
      var media = card.querySelector('.pcard__media');
      if (media){
        var sx = 0, sy = 0, tracking = false;
        media.addEventListener('touchstart', function(e){
          if (!e.touches || !e.touches[0]) return;
          sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
          if (images) neighbors(images, idx);
          else loadImages(function(){ neighbors(images, idx); });
        }, { passive: true });
        media.addEventListener('touchend', function(e){
          if (!tracking || !e.changedTouches || !e.changedTouches[0]) return;
          tracking = false;
          var dx = e.changedTouches[0].clientX - sx;
          var dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          go(dx < 0 ? 1 : -1);
        }, { passive: true });
      }

      /* Warm next/prev only — don't download every gallery image on hover */
      card.addEventListener('mouseenter', function(){
        if (images) neighbors(images, idx);
        else loadImages(function(){ neighbors(images, idx); });
      }, { once: true });
    });
  }

  /* search page cards (dss__card) — same embedded/prefetch pattern as .pcard */
  function initSearchCards(){
    function parseEmbedded(img){
      var raw = img.getAttribute('data-images');
      if (!raw) return null;
      try {
        var list = JSON.parse(raw);
        return Array.isArray(list) && list.length ? list : null;
      } catch (e) { return null; }
    }
    function prefetch(src){
      if (!src) return;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = src;
    }
    document.querySelectorAll('.dss__card').forEach(function(card){
      var media = card.querySelector('.dss__media');
      if (!media || media.querySelector('.pcard__nav')) return;
      var img = media.querySelector('img');
      if (!img) return;
      var rawHref = card.getAttribute('href') || '';
      var url = rawHref.split('?')[0].split('#')[0];
      var nav = document.createElement('div');
      nav.className = 'pcard__nav';
      nav.innerHTML = '<button type="button" aria-label="Previous image" data-dir="-1">‹</button><button type="button" aria-label="Next image" data-dir="1">›</button>';
      media.appendChild(nav);

      var images = parseEmbedded(img);
      var idx = 0;
      var loading = false;
      function loadImages(cb){
        if (images) { cb(); return; }
        if (loading || !url) return;
        loading = true;
        fetch(url + '.js').then(function(r){ return r.json(); }).then(function(p){
          images = (p.images || []).map(function(src){
            return src.replace(/(\.[a-z]+)(\?|$)/i, '_700x$1$2');
          });
          if (!images.length) images = [img.currentSrc || img.getAttribute('src')];
          loading = false;
          cb();
        }).catch(function(){ loading = false; });
      }
      function go(dir){
        function step(){
          if (!images || images.length < 2) return;
          idx = (idx + dir + images.length) % images.length;
          img.src = images[idx];
          img.removeAttribute('srcset');
          prefetch(images[(idx + 1) % images.length]);
          prefetch(images[(idx - 1 + images.length) % images.length]);
        }
        if (images) step();
        else loadImages(step);
      }
      nav.querySelectorAll('button').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          go(parseInt(btn.dataset.dir, 10) || 1);
        });
      });
      card.addEventListener('mouseenter', function(){
        if (images) {
          prefetch(images[1] || images[0]);
        } else {
          loadImages(function(){ if (images && images[1]) prefetch(images[1]); });
        }
      }, { once: true });
    });
  }

  /* cart count from Shopify cart API */
  function refreshCartCount(){
    var el = document.getElementById('cartCount');
    if (!el) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      el.textContent = c.item_count || 0;
      el.classList.toggle('show', c.item_count > 0);
    }).catch(function(){});
  }

  /* hero background video — MP4 only, force muted autoplay on mobile */
  function initHeroVideo(){
    document.querySelectorAll('#top .hero__media:not(.launch__media)').forEach(function(media){
      var v = media.querySelector('.hero__video, .launch__video');
      if (!v) return;
      var isLaunch = media.classList.contains('launch__media');
      var fallback = media.querySelector('.hero__fallback');
      var fallbackUrl = media.getAttribute('data-launch-fallback');
      var blocked = false;
      var tries = 0;
      var maxTries = isLaunch ? 24 : 14;

      function ensureFallbackEl(){
        if (fallback || !fallbackUrl) return fallback;
        fallback = document.createElement('img');
        fallback.className = 'hero__fallback';
        fallback.alt = '';
        fallback.decoding = 'async';
        fallback.src = fallbackUrl;
        media.appendChild(fallback);
        return fallback;
      }

      function showFallback(){
        if (blocked || !fallbackUrl) return;
        ensureFallbackEl();
        if (!fallback) return;
        blocked = true;
        media.classList.add('is-autoplay-blocked');
        try { v.pause(); } catch (e) {}
      }

      function playing(){
        return !v.paused && v.currentTime > 0;
      }

      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.controls = false;
      v.removeAttribute('controls');

      function tryPlay(){
        if (blocked || playing()) return;
        tries += 1;
        var p;
        try { p = v.play(); } catch (e) { p = null; }
        if (p && typeof p.then === 'function') {
          p.then(function(){
            if (!playing() && tries >= maxTries) showFallback();
          }).catch(function(){
            if (tries >= maxTries) showFallback();
            else setTimeout(tryPlay, 400);
          });
          return;
        }
        if (!playing()) {
          if (tries >= maxTries) showFallback();
          else setTimeout(tryPlay, 400);
        }
      }

      v.addEventListener('playing', function(){ tries = maxTries; }, { once: true });
      if (!isLaunch || v.paused) tryPlay();
      v.addEventListener('loadeddata', tryPlay, { once: true });
      v.addEventListener('canplay', tryPlay, { once: true });
      document.addEventListener('visibilitychange', function(){
        if (!document.hidden && !blocked) tryPlay();
      });
      window.addEventListener('pageshow', function(){
        if (!blocked) tryPlay();
      });
    });
  }

  function initLaunchCountdown(){
    var root = document.querySelector('[data-launch-countdown]');
    if (!root) return;

    // While gated, keep the address bar on the homepage (deep links still render countdown first).
    var path = window.location.pathname || '/';
    if (path !== '/' && path !== '') {
      window.location.replace('/');
      return;
    }

    // Bypass key is NEVER read from countdown HTML. Cookie persistence is handled
    // only when Liquid already validated ?ds_access= (see data-launch-grant-cookie).

    var targetMs = Date.parse(root.dataset.launchAt || '');
    if (!targetMs || isNaN(targetMs)) return;

    var daysEl = root.querySelector('[data-launch-days]');
    var hoursEl = root.querySelector('[data-launch-hours]');
    var minsEl = root.querySelector('[data-launch-minutes]');
    var secsEl = root.querySelector('[data-launch-seconds]');
    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

    function pad(n){ return String(n).padStart(2, '0'); }

    function tick(){
      var diff = targetMs - Date.now();
      if (diff <= 0) {
        window.location.reload();
        return;
      }
      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400); total %= 86400;
      var h = Math.floor(total / 3600); total %= 3600;
      var m = Math.floor(total / 60);
      var s = total % 60;
      daysEl.textContent = pad(d);
      hoursEl.textContent = pad(h);
      minsEl.textContent = pad(m);
      secsEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
    root.classList.add('in');
  }

  /** Persist launch preview cookie only after server-side ?ds_access= validation. */
  function initLaunchPreviewGrant(){
    var el = document.querySelector('[data-launch-grant-cookie]');
    if (!el) return;
    var key = el.getAttribute('data-launch-grant-cookie') || '';
    if (!key) return;
    try {
      var secure = location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = 'ds_launch_preview=' + encodeURIComponent(key) + '; path=/; max-age=' + (60 * 60 * 24 * 30) + '; SameSite=Lax' + secure;
      el.removeAttribute('data-launch-grant-cookie');
      if (el.parentNode) el.parentNode.removeChild(el);
      if (window.history && window.history.replaceState) {
        var clean = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, clean);
      }
    } catch (e) {}
  }

  function init(){
    observeReveals();
    if (!reduce) parLoop();
    initHeroVideo();
    initLaunchPreviewGrant();
    initLaunchCountdown();
    initArtistCarousel();
    initCollectionCarousel();
    initProductCards();
    initSearchCards();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
